<template>
  <div class="p-4 border rounded-lg">
    <div class="animate-pulse">
      <div class="flex items-center">
        <div class="w-10 h-10 rounded-full bg-shimmer dark:bg-gray-850"></div>
        <div class="ms-2">
          <div class="h-3 rounded-md bg-shimmer w-48 dark:bg-gray-850"></div>
          <div class="flex">
            <Icon
              v-for="n in 5"
              :key="`star-${n}`"
              name="MdiStar"
              class="w-6 h-6 text-gray-200 block"
            />
          </div>
        </div>
      </div>

      <div class="space-y-2 mt-4">
        <div class="h-3 rounded-md dark:bg-gray-850 bg-shimmer"></div>
        <div class="h-3 rounded-md dark:bg-gray-850 bg-shimmer"></div>
        <div class="h-3 rounded-md dark:bg-gray-850 bg-shimmer"></div>
        <div class="h-3 rounded-md dark:bg-gray-850 bg-shimmer w-24"></div>
      </div>
    </div>
  </div>
</template>
